import { useEffect, useState } from "react";
import api from "@/lib/api";

export const UI_TEXTS_DEFAULTS = {
  nav_home: "Accueil",
  nav_shop: "Boutique",
  nav_rosters: "Rosters",
  nav_drafter: "Drafter",
  nav_results: "Résultats",
  nav_news: "Actualités",
  nav_partners: "Partenaires",
  nav_contact: "Contact",
  partners_label: "Partenariats",
  partners_title: "Nos partenaires",
  partners_subtitle: "Ils nous font confiance et nous accompagnent dans l'aventure Emisphere.",
  match_opponent_link: "Voir {opponent} (OP.GG / lien adverse)",
  match_stream_link: "Voir le stream",
  match_mvp_label: "MVP",
  match_countdown_prefix: "Coup d'envoi dans",
  shop_label: "Boutique officielle",
  shop_title: "Nos maillots 2026",
  shop_teaser_soon: "Prochainement",
  results_label: "Compétition",
  results_title: "Résultats & calendrier",
  results_filter_all: "Tous les matchs",
  results_empty: "Aucun match pour ce filtre.",
  rosters_label: "Nos effectifs",
  rosters_title: "Les rosters Emisphere",
  roster_opgg_label: "Profil OP.GG",
  roster_r6_label: "Profil R6 Tracker",
  news_page_label: "Communauté",
  news_page_title: "Actualités & annonces",
  contact_label: "Contact",
  contact_title: "Nous contacter",
  contact_socials_label: "Réseaux sociaux",
  faq_label: "FAQ",
  faq_title: "Questions fréquentes",
  home_competition_label: "Compétition",
  home_community_label: "Communauté",
  home_manifesto_title: "Ce qui nous fait jouer",
  fanwall_label: "Mur de fans",
  fanwall_title: "Ils portent les couleurs",
  fanwall_subtitle: "Nos supporters aux couleurs Emisphere. À votre tour : envoyez votre photo avec le maillot !",
  fanwall_submit: "Envoyer ma photo",
  fanwall_empty: "Le mur est encore vide — soyez le premier supporter à apparaître ici !",
  footer_baseline: "Dominer la Faille. Écrire l'Histoire.",
};

let cache = null;

export function useUiTexts() {
  const [texts, setTexts] = useState(cache || UI_TEXTS_DEFAULTS);
  useEffect(() => {
    if (cache) return;
    api.get("/ui-texts")
      .then((r) => {
        cache = { ...UI_TEXTS_DEFAULTS, ...r.data };
        setTexts(cache);
      })
      .catch(() => {});
  }, []);
  return texts;
}

export function invalidateUiTexts() {
  cache = null;
  navCache = null;
}

export const NAV_ORDER_DEFAULT = ["home", "shop", "rosters", "drafter", "results", "news", "partners", "contact"];

let navCache = null;

export function useNav() {
  const [nav, setNav] = useState(navCache || { order: NAV_ORDER_DEFAULT, custom: [] });
  useEffect(() => {
    if (navCache) return;
    api.get("/nav")
      .then((r) => {
        if (r.data.order?.length) {
          navCache = { order: r.data.order, custom: r.data.custom || [] };
          setNav(navCache);
        }
      })
      .catch(() => {});
  }, []);
  return nav;
}
